import {StudentForEnrollment} from "@/shared/legacyTypes/fetchEnrollmentDataTypes";
import AlertBox, {AlertType} from "../../../../../_components/AlertBox";
import Radio from "../../../../../_components/forms/Radio";
import RadioGroup from "../../../../../_components/forms/RadioGroup";
import clsMerge from "../../../../../util/clsMerge";
import {Fragment} from "react";

interface StudentRadioGroupProps {
	selectedStudent: string | undefined;
	setSelectedStudent: (studentId: string) => void;
	students: StudentForEnrollment[];
}

const StudentRadioGroup: React.FC<StudentRadioGroupProps> = ({
	selectedStudent,
	setSelectedStudent,
	students,
}) => {
	if (students.length === 0) {
		return "You have no students attached to your account.";
	}
	return (
		<RadioGroup
			value={selectedStudent}
			onChange={setSelectedStudent}
			labelText="Students"
			classes={{
				root: "flex flex-col gap-2.5 overflow-y-auto max-h-80",
				label: "text-h5 font-black",
			}}
			isRequired
			hideLabelDecorators
		>
			{students.map(
				({
					platform_user_id: platformId,
					first_name: firstName,
					last_name: lastName,
					errors = [],
				}) => {
					const isDisabled = !!errors.length;
					return (
						<Fragment key={platformId}>
							<Radio
								value={platformId}
								isDisabled={isDisabled}
								className={clsMerge(!isDisabled && "cursor-pointer")}
							>
								<span className={clsMerge(isDisabled && "text-gray-600")}>
									{firstName} {lastName}
								</span>
							</Radio>
							{errors.length > 0 && (
								<AlertBox
									className="flex flex-col gap-2"
									type={AlertType.ERROR}
								>
									<div>{errors[0]}</div>
								</AlertBox>
							)}
						</Fragment>
					);
				}
			)}
		</RadioGroup>
	);
};

export default StudentRadioGroup;
